export default {
  install: function (Vue) {
    const KEY_VERSION = 'version'
    const KEY_ABOUT = 'about'
    const KEY_FOCUS = 'focus'
    const KEY_BABY = 'baby'
    const KEY_MENU = 'menu'
    const PREFIX_YEAR_MONTH = 'ym_'
    const PREFIX_DAY = 'd_'
    const MENU_KEYS = [
      'hash',
      'name',
      'start',
      'end',
      'hasAllergy',
      'memo',
      'nutrients',
      'amount',
      'unit'
    ]
    Vue.prototype.$storage = {
      set (key, value) {
        localStorage.setItem(key, value)
      },
      get (key) {
        const value = localStorage.getItem(key)
        if (value === undefined) {
          return null
        }
        return value
      },
      getVersion () {
        return this.get(KEY_VERSION)
      },
      setVersion (value) {
        this.set(KEY_VERSION, value)
      },
      doneAbout () {
        this.set(KEY_ABOUT, true)
      },
      getAbout () {
        const value = this.get(KEY_ABOUT)
        return value === null ? false : true
      },
      setFocusDate (date) {
        this.set(KEY_FOCUS, date)
      },
      getFocusDate () {
        return this.get(KEY_FOCUS)
      },
      convertYm (date) {
        return PREFIX_YEAR_MONTH + String(date.getFullYear()) + ('0' + String(date.getMonth() + 1)).slice(-2)
      },
      convertD (date) {
        return PREFIX_DAY + ('0' + String(date.getDate())).slice(-2)
      },
      getBabyData () {
        const babyString = this.get(KEY_BABY)
        const baby = babyString !== null ? JSON.parse(babyString) : null
        return baby
      },
      setBabyData (data) {
        this.set(KEY_BABY, JSON.stringify(data))
        return true
      },
      getAllMenu () {
        const result = []
        const menuString = this.get(KEY_MENU)
        let menu = menuString !== null ? JSON.parse(menuString) : {}
        Object.keys(menu).forEach((ym) => {
          Object.keys(menu[ym]).forEach((d) => {
            menu[ym][d].forEach((item) => {
              result.push(item)
            })
          })
        })
        return result
      },
      save (date, data) {
        const menuString = this.get(KEY_MENU)
        let menu = menuString !== null ? JSON.parse(menuString) : {}

        const ym = this.convertYm(date)
        const d = this.convertD(date)

        let monthData = {}
        if (ym in menu) {
          monthData = menu[ym]
        }
        let dateData = []
        if (d in monthData) {
          dateData = monthData[d]
        }

        let newData = dateData.filter(n => n.hash !== data.hash)
        newData.push(data)
        monthData[d] = newData
        menu[ym] = monthData
        this.set(KEY_MENU, JSON.stringify(menu))
        return true
      },
      getMenu (date, hash) {
        const menuString = this.get(KEY_MENU)
        let menu = menuString !== null ? JSON.parse(menuString) : {}
        const ym = this.convertYm(date)
        const d = this.convertD(date)
        
        let monthData = {}
        if (ym in menu) {
          monthData = menu[ym]
        } else {
          return null
        }
        let dateData = []
        if (d in monthData) {
          dateData = monthData[d]
        } else {
          return null
        }
        let data = null
        dateData.forEach((item) => {
          if (('hash' in item) && hash === item.hash) {
            data = item
          }
        })
        return data
      },
      deleteMenu (date, hash) {
        const menuString = this.get(KEY_MENU)
        let menu = menuString !== null ? JSON.parse(menuString) : {}

        const ym = this.convertYm(date)
        const d = this.convertD(date)

        let monthData = {}
        if (ym in menu) {
          monthData = menu[ym]
        }
        let dateData = []
        if (d in monthData) {
          dateData = monthData[d]
        }

        const newData = dateData.filter(n => n.hash !== hash)
        monthData[d] = newData
        menu[ym] = monthData
        this.set(KEY_MENU, JSON.stringify(menu))
        return true
      },
      clear () {
        localStorage.clear()
      },
      importJson (jsonStr) {
        const json = JSON.parse(jsonStr)
        if (json === null || json === undefined) {
          return false
        }
        let menuItems = {}
        Object.keys(json).forEach((ym) => {
          // 定数からインポートしたい PREFIX_YEAR_MONTH
          if (!ym.match(/^ym_20[0-9][0-9][01][0-9]$/)) {
            return false
          }
          let ymItems = {}
          const importYmItems = json[ym]
          Object.keys(importYmItems).forEach((d) => {
            // 定数からインポートしたい PREFIX_DAY
            if (!d.match(/^d_[0123]{1}[0-9]$/)) {
              return false
            }
            const importDateItems = json[ym][d]
            const dateItems = this.convertDateItems(importDateItems)
            ymItems[d] = dateItems
          })
          menuItems[ym] = ymItems
        })
        const menu = JSON.stringify(menuItems)
        if (menu !== null) {
          this.set(KEY_MENU, menu)
        }
        return true
      },
      convertDateItems (importDateItems) {
        let dateItems = []
        importDateItems.forEach((importDateItem) => {
          const dateMenu = this.convertMenu(importDateItem)
          if (dateMenu !== null) {
            dateItems.push(dateMenu)
          }
        })
        return dateItems
      },
      convertMenu (importDateItem) {
        let dateMenu = {}
        MENU_KEYS.forEach((key) => {
          if (!(key in importDateItem)) {
            return false
          } else {
            dateMenu[key] = importDateItem[key]
          }
        })
        if (this.isValidMenu(dateMenu)) {
          return dateMenu
        }
        return null
      },
      isValidMenu (data) {
        const requiredKeys = [
          'hash', 'name', 'start', 'end', 'nutrients'
        ]
        requiredKeys.forEach((key) => {
          if (!(key in data)){
            return false
          }
        })
        // TODO: 細かいバリデーション
        return true
      },
      extractMenuData () {
        return JSON.parse(this.get(KEY_MENU))
      }
      // TODO: 範囲指定でデータを取れるようにする
      // getRangeMenu(startDate, endDate) {
      //   const result = []
      //   if (!startDate.match(/^\d\d\d\d-[0-1][0-9]-[0-3][0-9]$/) || !endDate.match(/^\d\d\d\d-[0-1][0-9]-[0-3][0-9]$/)) {
      //     return result
      //   }
      //   const startParts = startDate.split('-')
      //   const endParts = endtDate.split('-')
      // },
    }
  }
}